import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrosoftTeams from './icon-microsoft-teams.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MicrosoftTeams {...validProps} />;
}
SvgComponent.iconName = 'microsoftTeams';

/**
 * @deprecated This is a legacy icon
 */
export const MicrosoftTeamsIcon = svgIconWrapper(SvgComponent);
